import { apiEndpoints } from '@/services/constants';
import { errorHandler } from '@/services/error-handler';
import httpServiceAuth from '@/services/http-service';

export default {
  state: {
    meetings: null,
    invitedAttendees: [],
    dateTime: null,
  },
  mutations: {
    setMeetings(state, payload) {
      state.meetings = payload;
    },
    setInvitedAttendees(state, payload) {
      state.invitedAttendees = payload;
    },
    setDateTime(state, payload) {
      state.dateTime = payload;
    },
  },
  actions: {
    setInvitedAttendees({ commit }, payload) {
      commit('setInvitedAttendees', payload);
    },
    getMeetings({ commit }) {
      const url = `${apiEndpoints.company.meetings}`;
      return httpServiceAuth
        .get(url)
        .then((response) => {
          commit('setMeetings', response.data.data);
        })
        .catch((error) => {
          if (error.response) {
            errorHandler(error.response);
          }
        });
    },
    setDateTime({ commit }, payload) {
      commit('setDateTime', payload);
    },
  },
};
